import React, { Component } from "react";
import { Spinner } from "react-bootstrap";

// font awesome
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export class DownloadExcelReport extends Component {
  delayUpdate = null;

  onDownload = e => {
    const { onClearDownload, resetPlaceholder } = this.props;
    onClearDownload && onClearDownload();
    resetPlaceholder && resetPlaceholder();
  };

  render() {
    const {
      props: {
        excelStyle,
        isLoading,
        downloadLink,
        onStartDownloading,
        iconClass,
        ministryComplianceExcelicon,
        iconClassName = iconClass
          ? "download-icons-excel-state"
          : "download-icons-excel",
        border,
        onDownloadLinkClick,
        isDraft,
        isMis,
        isPMG
      },
      onDownload
    } = this;
    let excelClassName;
    if (isDraft) {
      excelClassName = isPMG
        ? `download-excel-component-draft1`
        : `download-excel-component-draftNonPmg`;
      //excelClassName = `download-excel-component-draft1`;
    } else if (isMis) {
      excelClassName = `download-excel-component-mis`;
    } else {
      excelClassName = `download-excel-component ${
        excelStyle ? "excel-component" : ""
      } ${border ? "download-excel-radius" : ""}`;
    }

    const locPath = window.location.pathname;
    return (
      // <div className="download-excel-component">
      <span className={excelClassName}>
        {isLoading ? (
          <span className="download-icon downloading">
            <span className={iconClassName} />
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </span>
        ) : downloadLink ? (
          <span className="download-icon agenda-download-ppt-icon">
            <a
              className="download-img"
              download={"Abcde.xls"}
              href={downloadLink}
              target={iconClassName === "pdf-icon" ? "_blank" : ""}
              onClick={onDownload}
            >
              <FontAwesomeIcon icon={faDownload} size="2x" />
            </a>
          </span>
        ) : (
          <span
            onClick={onStartDownloading}
            className="download-mis-file download-icon "
          >
            <span
              className={
                ministryComplianceExcelicon
                  ? "download-icons-excel-ministry"
                  : iconClassName
              }
              style={{
                height:
                  iconClassName == "doc-icon" &&
                  (locPath == "/issue-detail" || locPath == "/detail-project")
                    ? "24px"
                    : "",
                width:
                  iconClassName == "doc-icon" &&
                  (locPath == "/issue-detail" || locPath == "/detail-project")
                    ? "24px"
                    : ""
              }}
            />
          </span>
        )}
      </span>

      // </div>
    );
  }
}
